
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/fitting-in",
      function () {
        return require("private-next-pages/archive/fitting-in.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/fitting-in"])
      });
    }
  